<template>
    <LayoutMain v-if="!showDetails" @editLink="editLink($event)" @addLink="addLink($event)" />
    <LinkDetails
        v-if="showDetails"
        :link="linkToEdit"
        :mode="mode"
        :backupData="backupData"
        @cancel="cancelLink"
        @save="saveLink"
    />
</template>

<script>
import { cloneDeep } from "@/shared/utils/helpers.js";
import { mapState, mapActions, mapMutations } from "vuex";
import LayoutMain from "./layout/LayoutMain.vue";
import LinkDetails from "./layout/LinkDetails.vue";
import { useCleanQueryParams } from "@/shared/utils/router/useCleanQueryParams";

const MODE = {
    create: "create",
    edit: "edit",
};

export default {
    components: {
        LayoutMain,
        LinkDetails,
    },
    setup() {
        const { cleanQueryParams } = useCleanQueryParams();
        return { cleanQueryParams };
    },
    data() {
        return {
            showDetails: false,
            linkToEdit: {},
            backupData: {},
            mode: "edit",
        };
    },
    computed: {
        ...mapState("player", ["headers"]),
    },
    mounted() {
        this.$watch(() => this.$route.query.open, this.handleQueryChange, {
            immediate: true,
        });
    },
    methods: {
        ...mapMutations("player", ["setHeaders", "addHeader", "changeHeader", "removeHeader"]),
        ...mapActions("player/projects", ["saveSnapshot"]),
        ...mapActions("alert", ["showWarnMessage"]),
        addLink(link) {
            this.addHeader(link);
            this.linkToEdit = link;
            this.mode = MODE.create;
            this.backupData = cloneDeep(this.linkToEdit);
            this.showDetails = true;
        },
        editLink(link) {
            this.linkToEdit = link;
            this.mode = MODE.edit;
            this.backupData = cloneDeep(this.linkToEdit);
            this.showDetails = true;
        },
        async saveLink() {
            if (!this.linkToEdit._created && !this.linkToEdit._deleted) {
                this.linkToEdit._changed = true;
            }
            await this.saveSnapshot();
            this.showDetails = false;
        },
        async cancelLink() {
            if (this.mode === MODE.edit) {
                this.changeHeader(this.backupData);
            } else {
                this.removeHeader(this.linkToEdit);
            }
            await this.saveSnapshot();
            this.showDetails = false;
        },
        handleQueryChange() {
            if (this.$route.query.open === "edit") {
                const headerId = +this.$route.query.id;
                setTimeout(() => {
                    this.cleanQueryParams(["open", "id"]);
                }, 100);

                const header = this.headers.find((h) => h.id === headerId);

                if (!header) {
                    return;
                }
                if (this.showDetails && (this.linkToEdit.id !== headerId || !headerId)) {
                    this.showWarnMessage({
                        message: this.$t("player.layout.unsaved_changes"),
                    });

                    return;
                }

                this.editLink(header);
            }
        },
    },
};
</script>
